import React from 'react';
import {useTranslation} from 'react-i18next';
import {isAmount} from '../shapes';
import {humanizeValue, isNumeric} from '../humanize';
import {DeltaChip} from '../primitives/DeltaChip';

function sideValue(value, t) {
    if (value === null || value === undefined || value === '') return '—';
    const humanized = humanizeValue('', value, t);
    return humanized === null ? '—' : humanized;
}

function extractAmount(value) {
    return isAmount(value) ? value.amount : value;
}

// before/after sueltos en la raíz del detail — fallback por FORMA para BUDGET_MODIFIED,
// platform changes de un campo y cualquier evento futuro con ese shape. Si el payload
// trae un field_label ya humanizado (platform changes), se usa como label de la fila.
export function SimpleBeforeAfterDetail({detail}) {
    const {t} = useTranslation();
    const beforeAmount = extractAmount(detail.before);
    const afterAmount = extractAmount(detail.after);
    const money = isAmount(detail.before) || isAmount(detail.after);
    const currency = (isAmount(detail.after) && detail.after.currency)
        || (isAmount(detail.before) && detail.before.currency) || null;
    const showDelta = isNumeric(beforeAmount) && isNumeric(afterAmount);
    return (
        <div className="ald-diff">
            <div className="ald-diff-row">
                {detail.field_label ? <span className="ald-diff-label">{detail.field_label}</span> : null}
                <span className="ald-diff-values">
                    <span className="ald-diff-before">{sideValue(detail.before, t)}</span>
                    <span className="ald-diff-arrow" aria-hidden="true">→</span>
                    <span className="ald-diff-after">{sideValue(detail.after, t)}</span>
                    {showDelta && <DeltaChip before={beforeAmount} after={afterAmount} money={money} currency={currency}/>}
                </span>
            </div>
        </div>
    );
}
